if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}


/* V34 — robust mobile gallery navigation fallback */
(function(){
  function initTrivareaMobileGallery(gallery){
    if(!window.matchMedia('(max-width: 749px)').matches) return;
    if(gallery.dataset.cv34Ready==='true') return;
    var list=gallery.querySelector('.product__media-list.slider--mobile');
    if(!list) return;
    gallery.dataset.cv34Ready='true';
    var wrapper=list.closest('slider-component');
    var prev=wrapper&&wrapper.querySelector('.slider-button--prev');
    var next=wrapper&&wrapper.querySelector('.slider-button--next');
    var dots=wrapper?Array.from(wrapper.querySelectorAll('.slider-counter__link--dots')):[];
    var startX=0,startY=0;

    function slides(){return Array.from(list.querySelectorAll('.product__media-item.slider__slide')).filter(function(el){return !el.classList.contains('hidden') && getComputedStyle(el).display!=='none';});}
    function currentIndex(){
      var arr=slides(); if(!arr.length) return 0;
      var left=list.scrollLeft;
      var best=0,dist=Infinity;
      arr.forEach(function(el,i){var d=Math.abs(el.offsetLeft-left);if(d<dist){dist=d;best=i;}});
      return best;
    }
    function go(i){
      var arr=slides(); if(!arr.length) return;
      i=Math.max(0,Math.min(i,arr.length-1));
      list.scrollTo({left:arr[i].offsetLeft,behavior:'smooth'});
      update(i);
    }
    function update(forced){
      var arr=slides(); var idx=typeof forced==='number'?forced:currentIndex();
      arr.forEach(function(el,i){el.classList.toggle('is-active',i===idx);});
      dots.forEach(function(dot,i){dot.classList.toggle('slider-counter__link--active',i===idx);});
      if(prev){prev.disabled=idx<=0;prev.style.opacity=idx<=0?'.45':'1';}
      if(next){next.disabled=idx>=arr.length-1;next.style.opacity=idx>=arr.length-1?'.45':'1';}
    }
    if(prev) prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(currentIndex()-1);},true);
    if(next) next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(currentIndex()+1);},true);
    dots.forEach(function(dot,i){dot.addEventListener('click',function(e){e.preventDefault();go(i);});});
    list.addEventListener('touchstart',function(e){if(!e.touches||!e.touches[0])return;startX=e.touches[0].clientX;startY=e.touches[0].clientY;},{passive:true});
    list.addEventListener('touchend',function(e){
      if(!e.changedTouches||!e.changedTouches[0])return;
      var dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      if(Math.abs(dx)>42 && Math.abs(dx)>Math.abs(dy)*1.15){go(currentIndex()+(dx<0?1:-1));}
    },{passive:true});
    var raf=0; list.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){update();});},{passive:true});
    update(0);
  }
  function initAll(){document.querySelectorAll('.main-product-section media-gallery').forEach(initTrivareaMobileGallery);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  window.addEventListener('resize',function(){if(window.matchMedia('(max-width: 749px)').matches)initAll();});
})();
